import { BehaviorContext } from '../behavior-context';
import { Behavior } from '../behavior';
import { Injectable } from '@angular/core';

// export async function setLoadingStateInactive(context: BehaviorContext<any>) {
//   const model = context.targetModel;
//   model.loading = false;
// }

@Injectable()
export class SetLoadingStateInactive implements Behavior {
  async execute(args: any, context: BehaviorContext): Promise<any> {
    if (context.target.model) {
      context.target.model.loading = false;
    }
  }
}
